import Vue from 'vue'
import Vuex from 'vuex'
import teb from './teb'
Vue.use(Vuex)
export default new Vuex.Store({
    modules:{
        teb
    }
})